import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import RoutesSwitcher from './components/App/Routes/RoutesSwitcher';
import { AuthProvider } from './contexts/AuthContext';
import { ConfigProvider } from './contexts/ConfigContext';
import { ContentProvider } from './contexts/ContentContext';
import { A2HSProvider } from './contexts/A2HSProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <A2HSProvider>
          <ConfigProvider>
            <ContentProvider>
              <RoutesSwitcher />
            </ContentProvider>
          </ConfigProvider>
        </A2HSProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;